module.exports = __webpack_public_path__ + "static/media/kfc.f0619d94.png";